export const WEBKIT_ENGINE_NAME = "WebKit";
export const MOBILE_PLATFORM_NAME = "mobile";
export const TABLET_PLATFORM_NAME = "tablet";
